import { UseQueryStateBaseResult } from 'store/api/api.types';
import { TranslationResult } from 'core/type/TranslationResult.types';

export type TranslationResultResponse = UseQueryStateBaseResult<TranslationResult>;
export const emptyTranslationResult: TranslationResult = { title: '', description: '', reply: '', languageId: -1 };
